<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ obj.VideoTitle }}</span>
        <div>(实际观看时间： {{ timecount }} {{ k == "NaN%" ? "0%" : k }})</div>
      </div>
      <video
        style="width: 100%; height: 8.75rem"
        :src="Url"
        :autoplay="false"
        @timeupdate="timeUpdate"
        controls
        id="myVideo"
        @ended="ended"
        @play="onStart"
        @pause="Stop"
      ></video>
    </el-card>
  </div>
</template>
<script>
import {
  GetVideoUrl,
  AddVideoStudyRecordInfo,
  OverVideoInfo,
  AddVideoTimeInfo,
} from "../../api/api";

export default {
  data() {
    return {
      Url: "",
      obj: {},
      userInfo: {},
      timecount: "00:00:00",
      StartTimecount: "00:00:00",
      hour: 0,
      minute: 0,
      second: 0,
      Starthour: 0,
      Startminute: 0,
      Startsecond: 0,
      timer: "",
      StartTimer: "",
      k: "",
      isOpen: true,
    };
  },
  created() {
    this.StartGetTimeInterval();
    this.userInfo = JSON.parse(window.localStorage.user);
    this.obj = JSON.parse(this.$route.query.obj);
    this.GetVideoUrl();
    this.AddVideoStudyRecordInfo();
  },
  beforeRouteLeave(to, from, next) {
    // 离开路由之前 ，判断一下是不是跳到下一个页面 // 是否保存当前页面
    // console.log(to.path, '查看路径，跳转的路径')
    const path = "/Teacher-Tain/detail"; // 路由配置里面的路由路径经
    // 判断两个路径是否一致
    if (to.path === path) {
      this.AddVideoTimeInfo();
      this.setData();
      next();
    } else {
      next();
    }
  },
  methods: {
    async AddVideoTimeInfo() {
      console.log("调用");
      let res = await AddVideoTimeInfo({
        teacherId: this.userInfo.TeacherId,
        videoId: this.obj.VideoId,
        time: this.time_to_sec(this.StartTimecount),
      });
    },
    setData() {
      this.StartTimecount = "00:00:00";
      this.Starthour = 0;
      this.Startminute = 0;
      this.Startsecond = 0;

      this.timecount = "00:00:00";
      this.hour = 0;
      this.minute = 0;
      this.second = 0;
      clearInterval(this.timer);
      clearInterval(this.StartTimer);
    },
    onStart() {
      console.log("开始录音");
      this.getTimeInterval();
    },
    Stop() {
      console.log("录音暂停");
      clearInterval(this.timer);
    },
    ended() {
      clearInterval(this.timer);
      // this.setData()
    },
    async OverVideoInfo() {
      let res = await OverVideoInfo({
        teacherId: this.userInfo.TeacherId,
        videoId: this.obj.VideoId,
      });
      if (res.data.success) {
        this.isOpen = false;
      }
    },
    timeUpdate(e) {
      //视频时长
      //   this.videoTime = parseInt(e.detail.duration);
      var currentIngTime = this.time_to_sec(this.timecount); //当前播放时间总和

      var k = ((currentIngTime / this.obj.TimeSec) * 100).toFixed(1) + "%";
      this.k = ((currentIngTime / this.obj.TimeSec) * 100).toFixed(1) + "%";
      let Num = Number(((currentIngTime / this.obj.TimeSec) * 100).toFixed(1));
      console.log(Num, this.k);
      if (k != "NaN%") {
        if (Num >= 80.0 && this.isOpen) {
          console.log("超过80%");
          this.OverVideoInfo();
        }
        if (k == "100.0%") {
          clearInterval(this.timer);
        }
      }
    },
    showNum(num) {
      if (num < 10) {
        return "0" + num;
      }
      return num;
    },
    // 计时器
    getTimeInterval() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.second += 1;
        if (this.second >= 60) {
          this.minute += 1;
          this.second = 0;
        }
        if (this.minute >= 60 && this.second >= 60) {
          this.minute += 0;
          this.hour += 1;
        }
        this.timecount =
          this.showNum(this.hour) +
          ":" +
          this.showNum(this.minute) +
          ":" +
          this.showNum(this.second);
      }, 1000);
    },
    time_to_sec(time) {
      var s = "";

      var hour = time.split(":")[0];
      var min = time.split(":")[1];
      var sec = time.split(":")[2];

      s = Number(hour * 3600) + Number(min * 60) + Number(sec);

      return s;
    },
    // 页面进入时候倒计时
    StartGetTimeInterval() {
      clearInterval(this.StartTimer);
      this.StartTimer = setInterval(() => {
        this.Startsecond += 1;
        if (this.Startsecond >= 60) {
          this.Startminute += 1;
          this.Startsecond = 0;
        }
        if (this.Startminute >= 60 && this.Startsecond >= 60) {
          this.Startminute += 0;
          this.Starthour += 1;
        }
        this.StartTimecount =
          this.showNum(this.Starthour) +
          ":" +
          this.showNum(this.Startminute) +
          ":" +
          this.showNum(this.Startsecond);
      }, 1000);
    },
    async AddVideoStudyRecordInfo() {
      let res = await AddVideoStudyRecordInfo({
        teacherId: this.userInfo.TeacherId,
        videoId: this.obj.VideoId,
      });
    },
    async GetVideoUrl() {
      let res = await GetVideoUrl({
        Id: this.obj.VideoId,
      });
      if (res.data.success) {
        this.Url = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    font-size: 0.225rem;
    font-weight: 600;
  }
  div {
    color: #333;
    font-size: 0.175rem;
  }
}
</style>